import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { IoMdPeople } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";
const route = all_routes;

const isWhatsappEnabled = true;
export const SidebarData = [
  {
    // label: "CRM",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
        link: route.agentDashboard,
      },
      {
        label: "Database",
        icon: "ti ti-user-up",
        link: route.agentContactList,
        submenu: false,
        showSubRoute: false,
        // submenuItems: [
        //   {
        //     label: "Contacts List",
        //     link: route.agentContactList,
        //     icon: <IoMdPeople />,
        //   },
        //   // {
        //   //   label: "FAQ",
        //   //   link: route.agentFaq,
        //   //   icon: <IoMdPeople />,
        //   // },
        // ],
      },
      {
        label: "Leads",
        icon: "ti ti-medal",
        submenu: false,
        showSubRoute: false,
        link: route.agentLeads,
        onClick: () => console.log("Leads Clicked"),
      },
      {
        label: "Campaigns",
        icon: "ti ti-speakerphone",
        submenu: false,
        showSubRoute: false,
        link: route.agentPowerDialer,
      },
      {
        label: "Calendar",
        icon: "ti ti-medal",
        submenu: false,
        showSubRoute: false,
        link: route.agentCalendar,
      },

      {
        label: "Whatsapp",
        icon: "ti ti-brand-whatsapp",
        submenu: true,
        showSubRoute: true,
        // link: route.whatsapp,
        submenuItems: [
          {
            label: "Chat",
            link: route.agentWhatsapp,
            icon: <IoMdPeople />,
          },
          {
            label: "History",
            link: route.agentWhatsappHistory,
            icon: <IoMdPeople />,
          },
          {
            label: "Campaigns",
            link: route.agentWabaCampaigns,
            icon: <IoMdPeople />,
          },
          {
            label: "Templates",
            link: route.agentWabaTemplates,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "Settings",
        icon: "ti ti-code",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Profile Settings",
            link: route.agentProfile,
            icon: <IoMdPeople />,
          },
          {
            label: "Dialer Settings",
            link: route.agentCallerSettings,
            icon: <IoMdPeople />,
          },
          {
            label: "Groups",
            link: route.agentGroups,
            icon: <IoMdPeople />,
          },
          {
            label: "Security",
            link: route.agentSecurity,
            icon: <IoMdPeople />,
          },
          {
            label: "FAQ",
            link: route.agentFaq,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "Sync And Integration",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
        link: route.agentSyncAndIntegration,
      },




      {
        label: "Call Recordings",
        icon: "ti ti-medal",
        submenu: false,
        showSubRoute: false,
        link: route.agentCallAndRecording,
      },
      {
        label: "Import And Export",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
        link: route.agentImportAndExport,
      },
      {
        label: "API Docs",
        icon: "ti ti-cloud-cog",
        submenu: false,
        showSubRoute: false,
        link: route.api,
      },
      {
        // label: "Help & Support",
        // icon: "ti ti-code",
        // submenu: true,
        // showSubRoute: false,
        // submenuItems: [
        //   {
        //     label: "New Ticket",
        //     link: route.agentHelpAndSupport,
        //     icon: <IoMdPeople />,
        //   },
        //   {
        //     label: "Existing Ticket",
        //     link: route.myTicketsAgent,
        //     icon: <IoMdPeople />,
        //   },
        // ],
        label: "Help & Support",
        icon: "ti ti-help",
        submenu: false,
        showSubRoute: false,
        link: route.myTicketsAgent,
      },
    ],
  },
];
